module.exports = __webpack_public_path__ + "static/media/warning.39d93868.svg";